import { IExternalLinks } from "../../../Types";

export const socialLinksHandler = (key: string, links: IExternalLinks[]) => {
  if (!links) return "";
  const matchedItems = links.find((link) => link.name === key);
  return matchedItems ? matchedItems.url : "";
};
